class FilterItem {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.dropdownId = self.elem.getAttribute('href').replace('#', '');
        self.dropdown = document.getElementById(self.dropdownId);
        self.backBtn = self.dropdown.querySelector('[data-filters-dropdown-back-btn]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.elem.addEventListener('click', evt => {
            evt.preventDefault();

            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });

        self.backBtn.addEventListener('click', evt => {
            self.close();
        });
    }

    open() {
        let self = this;

        // Activate dropdown
        self.dropdown.classList.add('is-active');

        // Force a re-paint
        let reflow = self.dropdown.offsetHeight;

        // Show dropdown (slide it in)
        self.dropdown.classList.add('is-open');

        // Set aria-expanded attribute to true
        self.elem.setAttribute('aria-expanded', true);

        // Focus on first focusable element in dropdown
        let firstFocusableElem = self.dropdown.querySelector('input, a');

        if(firstFocusableElem) {
            self.dropdown.querySelector('input, a').focus({preventScroll: true});
        }

        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    close() {
        let self = this; 

        // Hide panel (slide it out)
        self.dropdown.classList.remove('is-open');

        // Function to remove is-active class from panel once slide transition is complete
        let func = function() {
            self.dropdown.classList.remove('is-active');

            // Set aria-expanded attribute to false
            self.elem.setAttribute('aria-expanded', false);

            // Remove event listeners
            self.removeEventListeners();

            self.isOpen = false;

            // Return focus to the trigger
            self.elem.focus({preventScroll: true});

            // Stop listening for end of transition
            self.dropdown.removeEventListener('transitionend', func);
        }

        let transitions = self.dropdown.getAnimations();

        if(transitions.length > 0) {
            // Listen for end of slide transition to deactivate the dropdown
            self.dropdown.addEventListener('transitionend', func, false);
        } else {
            // Deactivate the dropdown immediately
            func();
        }
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        if (evt.target !== self.dropdown && !self.dropdown.contains(evt.target) && evt.target !== self.elem && !self.elem.contains(evt.target)) {

            // Close the dropdown
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default FilterItem;
